export default __webpack_public_path__ + "static/media/popular.c289d2a9.jpg";